/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V8 Over API Specification
 * OpenAPI spec version: 0.0.8
 */

/**
 * 경로 규칙 (kubernetes 전용)
 */
export type _RequestPathRule = (typeof _RequestPathRule)[keyof typeof _RequestPathRule];

export const _RequestPathRule = {
  NAMESPACE: 'NAMESPACE',
  NODE: 'NODE',
} as const;
